export default "__VITE_ASSET__D0tyCzTo__"